// This file is generated by a script. Do not edit this file directly.
(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "react"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("react"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.react);
    global.Bold = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _react) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.Bold = void 0;
  _react = _interopRequireDefault(_react);
  function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
  function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
  var Bold = _exports.Bold = function Bold(props) {
    return /*#__PURE__*/_react["default"].createElement("svg", _extends({
      viewBox: "0 0 20 20"
    }, props), /*#__PURE__*/_react["default"].createElement("path", {
      d: "M5.29119 17V3.90909H10.3026C11.2486 3.90909 12.0348 4.05824 12.6612 4.35653C13.2919 4.65057 13.7628 5.05327 14.0739 5.56463C14.3892 6.07599 14.5469 6.65554 14.5469 7.30327C14.5469 7.83594 14.4446 8.2919 14.2401 8.67116C14.0355 9.04616 13.7607 9.35085 13.4155 9.58523C13.0703 9.8196 12.6847 9.98793 12.2585 10.0902V10.218C12.723 10.2436 13.1683 10.3864 13.5945 10.6463C14.0249 10.902 14.3764 11.2642 14.6491 11.733C14.9219 12.2017 15.0582 12.7685 15.0582 13.4332C15.0582 14.1108 14.8942 14.7202 14.5661 15.2614C14.2379 15.7983 13.7436 16.2223 13.0831 16.5334C12.4226 16.8445 11.5916 17 10.5902 17H5.29119ZM7.66264 15.0185H10.2131C11.0739 15.0185 11.6939 14.8544 12.0732 14.5263C12.4567 14.1939 12.6484 13.7678 12.6484 13.2479C12.6484 12.8601 12.5526 12.5107 12.3608 12.1996C12.169 11.8842 11.8963 11.6371 11.5426 11.4581C11.1889 11.2749 10.767 11.1832 10.277 11.1832H7.66264V15.0185ZM7.66264 9.47656H10.0085C10.4176 9.47656 10.7862 9.40199 11.1143 9.25284C11.4425 9.09943 11.7003 8.88423 11.8878 8.60724C12.0795 8.32599 12.1754 7.99361 12.1754 7.61009C12.1754 7.10298 11.9964 6.68537 11.6385 6.35724C11.2848 6.02912 10.7585 5.86506 10.0597 5.86506H7.66264V9.47656Z",
      fill: "#212B36"
    }));
  };
});
